import QRCode from 'views/molecules/QRCode/QRCode';

export default QRCode;
